import { useState } from "react";
import { Star } from "react-feather";
import { Fragment } from "react/jsx-runtime";
import { FavoriteMessage, FavoriteTitle, Href } from "../../../../../Constants/Constants";
import { FavoriteData } from "../../../../../Data/Messenger/Messenger";
import { useAppDispatch, useAppSelector } from "../../../../../ReduxToolkit/Hooks";
import { setFavoriteActive } from "../../../../../ReduxToolkit/Reducers/Messenger/MainSidebar";
import { dynamicImage, Image } from "../../../../../Utils";
import CommonLeftHeading from "../Common/CommonLeftHeading";
import FavoriteModal from "./FavoriteModal";

const Favorite = () => {
  const [modal, setModal] = useState(false);
  const dispatch = useAppDispatch();
  const { favoriteActive } = useAppSelector((state) => state.mainSidebar);
  const toggle = () => setModal(!modal);
  return (
    <Fragment>
      <CommonLeftHeading title={FavoriteTitle} sunTitle={FavoriteMessage} search modalToggle={toggle}/>
      <FavoriteModal modal={modal} toggle={toggle}/>
      <ul className="chat-main">
        {FavoriteData.map((item, index) => (
          <li className="border-0" key={index}>
            <div className="bookmark-box">
              <div className="chat-box">
                <div className="d-flex">
                  <div className={`profile ${item.class}`}>
                    <Image className="bg-img img-fluid" src={dynamicImage(`contact/${item.image}.jpg`)} alt="Avatar" />
                  </div>
                  <div className="details">
                    <h4>{item.title}</h4>
                    <h5>{item.text}</h5>
                  </div>
                  <div className="flex-grow-1">
                    <a className={`icon-btn btn-${favoriteActive[index] ? "primary" : "outline-primary"} btn-sm pull-right favourite`} href={Href} onClick={() => dispatch(setFavoriteActive(index))}>
                      <Star />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </Fragment>
  );
};

export default Favorite;
